import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { ProfitabilityApiAdapter } from '../adapters/ProfitabilityApiAdapter';
import type { ProfitabilityAdCampaignsListResponse } from '../models/Profitability';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ProfitabilityApiAdapter(httpClient);

export const useAdSpendCampaigns = (enabled = true) => {
  return useQuery<ProfitabilityAdCampaignsListResponse, Error>({
    queryKey: ['profitability', 'ad-spend', 'campaigns'],
    queryFn: () => adapter.getAdSpendCampaigns(),
    enabled,
    staleTime: 30 * 1000,
  });
};
